<ng-container *ngIf="firstReject">
  <div [ngClass]="fullscreen ? (firstTime ? 'main-observations footer-height-max-firsttime' : (observations.length > 1 ? 'main-observations footer-height-max' : 'main-observations footer-height-mid')) : 'main-observations footer-height-min'">
    <div class="grid-title title">
      <div class="grid-title-1 general-comments-title" *ngIf="generalComment && fullscreen">
        Comentarios generales
      </div>
      <div class="grid-title-2 general-comments" *ngIf="generalComment && fullscreen">
        {{ generalComment }}
      </div>
      <div class="grid-title-3">
        <span *ngIf="!firstTime">El Handover fue revisado, indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
        <span *ngIf="firstTime">Indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
      </div>
      <div class="grid-title-4">
        <button class="button-max-min" *ngIf="!fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">open_in_full</mat-icon></button>
        <button class="button-max-min" *ngIf="fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">close_fullscreen</mat-icon></button>
      </div>
    </div>
    <div *ngFor="let observation of observations; let i = index;">
      <div *ngIf="!observation.handoverId" class="observations-firsttime-container">
        <mat-slide-toggle class="observations-firsttime" [(ngModel)]="observation.handoverObservationChecked"
         (ngModelChange)="buildRejectToolTip()" (change)="onChangeValue()">
          <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
          <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
          <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
        </mat-slide-toggle>
        <mat-form-field class="observation-firsttime" *ngIf="observation.handoverObservationChecked">
          <textarea rows="4" maxlength="255"  matInput placeholder="Describa observación" [(ngModel)]="observation.handoverObservation"
            [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
          <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
            Este campo es obligatorio.
          </mat-hint>
        </mat-form-field>
        <div class="grid-receiver-item-divider-firsttime"><mat-divider></mat-divider></div>
      </div>
      <div *ngIf="observation.handoverId" [ngClass]="{'grid-receiver': observation.handoverId}">
        <div class="grid-receiver-item grid-receiver-item1">
          <span class="observation-type">{{ observation.handoverObservationTypeDescription }}: </span>
          <span class="observation">"{{ observation.receiverObservation }}"</span>
        </div>
        <div class="grid-receiver-item grid-receiver-item2">
          <span class="observation-date">Actualización de dato al {{ observation.receiverObservationDatetime }}:</span>
        </div>
        <div class="grid-receiver-item3">
          <a *ngIf="viewHistoryHoType(observation.handoverObservationTypeId)" class="view-history"
            (click)="viewObservationsHistory(observation.handoverObservationTypeId)">Ver Historial</a>
        </div>
        <div class="grid-receiver-item4">
          <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
        </div>
        <div class="grid-receiver-item grid-receiver-item5">
          <div *ngIf="observation.emitterObservationSolved">
            <span class="emitter-name">{{ observation.emitterName }} indica: </span>
            <mat-icon class="check-fill-green" svgIcon="check-fill-green"></mat-icon>
            <span class="observation-resolved" *ngIf="observation.emitterObservationSolved">Se pudo resolver</span>
          </div>
          <div *ngIf="!observation.emitterObservationSolved">
            <span class="emitter-name">{{ observation.emitterName }} indica: </span>
            <mat-icon class="check-fill-red" svgIcon="close-fill-red"></mat-icon>
            <span class="observation-not-resolved" *ngIf="!observation.emitterObservationSolved">No se pudo resolver</span>
          </div>
        </div>
        <div class="grid-receiver-item6">
          <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
        </div>
        <div class="grid-receiver-item grid-receiver-item7">
          <span class="emitter-name">Y comenta: </span><span class="observation">{{ observation.emitterObservation != '' ? '"' + observation.emitterObservation + '"' : '' }}</span>
        </div>
        <div class="grid-receiver-item grid-receiver-item8 observations">
          <mat-slide-toggle [(ngModel)]="observation.handoverObservationChecked" (ngModelChange)="buildRejectToolTip()"
          (change)="onChangeValue()">
            <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
            <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
            <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
          </mat-slide-toggle>
          <mat-form-field *ngIf="observation.handoverObservationChecked">
            <textarea matInput rows="4" maxlength="255" placeholder="Describa observación" [(ngModel)]="observation.handoverObservation" 
              [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
            <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
              Este campo es obligatorio.
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="grid-receiver-item-divider"><mat-divider></mat-divider></div>
      </div>
    </div>
    <div class = "container-columns">
      <!-- File Attachment -->
      <div>
        <ng-container *ngIf="observationAttachment?.length < fileLimit">
            <input
              type="file"
              class="file-input"
              accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
              (change)="onFileSelected($event)"
              #fileUpload
              style="display: none"
            />
            <div class="attach" title="Documento">
              <button
                mat-button
                class = "upload-button"
                (click)="fileUpload.click()">
                <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
              </button><br/>
              <span>Archivos Excel, PDF e Imágenes</span>
            </div>
        </ng-container>
        <div class = "attachment" *ngFor="let f of observationAttachment">
          <a
              class="attachment-link"
              href="{{dhoApiUrl}}/{{ f?.filePath }}"
              download="{{ f?.fileOriginalName }}"
              target="_blank"
          >
              {{ f?.fileOriginalName }}
          </a>
          <!-- Boton borrar-->
          <button
              mat-button
              class="delete-button"
              (click)="deleteObservationAttachment(f.fileId)"
          >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </div>
      </div>
      <div class="acciones" *ngIf="havePermissionAccept">
        <span matTooltip={{rejectButtonToolTip}}>
          <button mat-button class="no-button" (click)="reject();" [disabled]="isDisabledRejectButton()">Rechazar</button>
        </span>
        <button mat-button class="yes-button" (click)="accept();" [disabled]="isDisabledAcceptButton()">Aceptar</button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!firstReject">
  <div class="tabs" *ngIf="fullscreen">
      <button mat-button [ngClass]="operationsVisible ? 'tab-button border-selected' : 'tab-button border-not-selected'" (click)="showTab('operations');">
        <span [ngClass]="operationsVisible ? 'profileNameCircle profileNameCircle-selected' : 'profileNameCircle profileNameCircle-not-selected'">
          {{ getInitialsOfName(handover?.sendingUser) }}
        </span>
        <span [ngClass]="operationsVisible ? 'span-selected': 'span-not-selected'"><span>Enviado {{ isDr ? 'para' : 'por' }}</span> Operaciones</span>
      </button>
      <button mat-button [ngClass]="operationsVisible ? 'tab-button border-not-selected' : 'tab-button border-selected'" (click)="showTab('engineering');">
        <span [ngClass]="operationsVisible ? 'profileNameCircle profileNameCircle-not-selected' : 'profileNameCircle profileNameCircle-selected'">
          {{ isDr ? getInitialsOfName(handover?.sendingUser) : getInitialsOfName(handover?.sendingEngineerUser) }}
        </span>
        <span [ngClass]="operationsVisible ? 'span-not-selected' : 'span-selected'"><span>Enviado {{ isDr ? 'para' : 'por' }}</span> Ingeniería</span>
      </button>
  </div>
  <ng-container *ngIf="operationsVisible">
    <div [ngClass]="fullscreen ? (firstTime ? 'main-observations footer-height-max-firsttime' : (observations.length > 1 ? 'main-observations footer-height-max' : 'main-observations footer-height-mid')) : 'main-observations footer-height-min'">
      <div class="grid-title title">
        <div class="grid-title-1 general-comments-title" *ngIf="generalComment && fullscreen">
          Comentarios generales
        </div>
        <div class="grid-title-2 general-comments" *ngIf="generalComment && fullscreen">
          {{ generalComment }}
        </div>
        <div class="grid-title-3">
          <span *ngIf="!firstTime">El Handover fue revisado, indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
          <span *ngIf="firstTime">Indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
        </div>
        <div class="grid-title-4">
          <button class="button-max-min" *ngIf="!fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">open_in_full</mat-icon></button>
          <button class="button-max-min" *ngIf="fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">close_fullscreen</mat-icon></button>
        </div>
      </div>
      <div *ngFor="let observation of observations; let i = index;">
        <div *ngIf="!observation.handoverId" class="observations-firsttime-container">
          <mat-slide-toggle class="observations-firsttime" [(ngModel)]="observation.handoverObservationChecked" (ngModelChange)="buildRejectToolTip()"
          (change)="onChangeValue()" [disabled]="cantEditObservations()">
            <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
            <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
            <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
          </mat-slide-toggle>
          <mat-form-field class="observation-firsttime" *ngIf="observation.handoverObservationChecked">
            <textarea rows="4" maxlength="255"  matInput placeholder="Describa observación" [(ngModel)]="observation.handoverObservation"
              [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
            <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
              Este campo es obligatorio.
            </mat-hint>
          </mat-form-field>
          <div class="grid-receiver-item-divider-firsttime"><mat-divider></mat-divider></div>
        </div>
        <div *ngIf="observation.handoverId" [ngClass]="{'grid-receiver': observation.handoverId}">
          <div class="grid-receiver-item grid-receiver-item1">
            <span class="observation-type">{{ observation.handoverObservationTypeDescription }}: </span>
            <span class="observation">"{{ observation.receiverObservation }}"</span>
          </div>
          <div class="grid-receiver-item grid-receiver-item2">
            <span class="observation-date">Actualización de dato al {{ observation.receiverObservationDatetime }}:</span>
          </div>
          <div class="grid-receiver-item3">
            <a *ngIf="viewHistoryHoType(observation.handoverObservationTypeId)" class="view-history"
              (click)="viewObservationsHistory(observation.handoverObservationTypeId)">Ver Historial</a>
          </div>
          <div class="grid-receiver-item4">
            <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
          </div>
          <div class="grid-receiver-item grid-receiver-item5">
            <div *ngIf="observation.emitterObservationSolved">
              <span class="emitter-name">{{ observation.emitterName }} indica: </span>
              <mat-icon class="check-fill-green" svgIcon="check-fill-green"></mat-icon>
              <span class="observation-resolved" *ngIf="observation.emitterObservationSolved">Se pudo resolver</span>
            </div>
            <div *ngIf="!observation.emitterObservationSolved">
              <span class="emitter-name">{{ observation.emitterName }} indica: </span>
              <mat-icon class="check-fill-red" svgIcon="close-fill-red"></mat-icon>
              <span class="observation-not-resolved" *ngIf="!observation.emitterObservationSolved">No se pudo resolver</span>
            </div>
          </div>
          <div class="grid-receiver-item6">
            <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
          </div>
          <div class="grid-receiver-item grid-receiver-item7">
            <span class="emitter-name">Y comenta: </span><span class="observation">{{ observation.emitterObservation != '' ? '"' + observation.emitterObservation + '"' : '' }}</span>
          </div>
          <div class="grid-receiver-item grid-receiver-item8 observations">
            <mat-slide-toggle [(ngModel)]="observation.handoverObservationChecked" (ngModelChange)="buildRejectToolTip()"
            (change)="onChangeValue()" [disabled]="cantEditObservations()">
              <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
              <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
              <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
            </mat-slide-toggle>
            <mat-form-field *ngIf="observation.handoverObservationChecked">
              <textarea matInput rows="4" maxlength="255" placeholder="Describa observación" [(ngModel)]="observation.handoverObservation" 
                [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
              <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
                Este campo es obligatorio.
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="grid-receiver-item-divider"><mat-divider></mat-divider></div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!operationsVisible">
    <div [ngClass]="fullscreen ? (firstTime ? 'main-observations footer-height-max-firsttime' : (engineeringOservations.length > 1 ? 'main-observations footer-height-max' : 'main-observations footer-height-mid')) : 'main-observations footer-height-min'">
      <div class="grid-title title">
        <div class="grid-title-1 general-comments-title" *ngIf="generalComment && fullscreen">
          Comentarios generales
        </div>
        <div class="grid-title-2 general-comments" *ngIf="generalComment && fullscreen">
          {{ generalComment }}
        </div>
        <div class="grid-title-3">
          <span *ngIf="!firstTime">El Handover fue revisado, indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
          <span *ngIf="firstTime">Indicá a continuación si tenés alguna observación en la aceptación o rechazo del Handover</span>
        </div>
        <div class="grid-title-4">
          <button class="button-max-min" *ngIf="!fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">open_in_full</mat-icon></button>
          <button class="button-max-min" *ngIf="fullscreen" (click)="resizeFooter()"><mat-icon class="material-icons-outlined">close_fullscreen</mat-icon></button>
        </div>
      </div>
      <div *ngFor="let observation of engineeringOservations; let i = index;">
        <div *ngIf="!observation.handoverId" class="observations-firsttime-container">
          <mat-slide-toggle class="observations-firsttime" [(ngModel)]="observation.handoverObservationChecked" (ngModelChange)="buildRejectToolTip()"
          (change)="onChangeValue()" [disabled]="cantEditObservations()">
            <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
            <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
            <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
          </mat-slide-toggle>
          <mat-form-field class="observation-firsttime" *ngIf="observation.handoverObservationChecked">
            <textarea rows="4" maxlength="255"  matInput placeholder="Describa observación" [(ngModel)]="observation.handoverObservation"
              [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
            <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
              Este campo es obligatorio.
            </mat-hint>
          </mat-form-field>
          <div class="grid-receiver-item-divider-firsttime"><mat-divider></mat-divider></div>
        </div>
        <div *ngIf="observation.handoverId" [ngClass]="{'grid-receiver': observation.handoverId}">
          <div class="grid-receiver-item grid-receiver-item1">
            <span class="observation-type">{{ observation.handoverObservationTypeDescription }}: </span>
            <span class="observation">"{{ observation.receiverObservation }}"</span>
          </div>
          <div class="grid-receiver-item grid-receiver-item2">
            <span class="observation-date">Actualización de dato al {{ observation.receiverObservationDatetime }}:</span>
          </div>
          <div class="grid-receiver-item3">
            <a *ngIf="viewHistoryHoType(observation.handoverObservationTypeId)" class="view-history"
              (click)="viewObservationsHistory(observation.handoverObservationTypeId)">Ver Historial</a>
          </div>
          <div class="grid-receiver-item4">
            <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
          </div>
          <div class="grid-receiver-item grid-receiver-item5">
            <div *ngIf="observation.emitterObservationSolved">
              <span class="emitter-name">{{ observation.emitterName }} indica: </span>
              <mat-icon class="check-fill-green" svgIcon="check-fill-green"></mat-icon>
              <span class="observation-resolved" *ngIf="observation.emitterObservationSolved">Se pudo resolver</span>
            </div>
            <div *ngIf="!observation.emitterObservationSolved">
              <span class="emitter-name">{{ observation.emitterName }} indica: </span>
              <mat-icon class="check-fill-red" svgIcon="close-fill-red"></mat-icon>
              <span class="observation-not-resolved" *ngIf="!observation.emitterObservationSolved">No se pudo resolver</span>
            </div>
          </div>
          <div class="grid-receiver-item6">
            <mat-divider [vertical]="true" class="vertical-divider"></mat-divider>
          </div>
          <div class="grid-receiver-item grid-receiver-item7">
            <span class="emitter-name">Y comenta: </span><span class="observation">{{ observation.emitterObservation != '' ? '"' + observation.emitterObservation + '"' : '' }}</span>
          </div>
          <div class="grid-receiver-item grid-receiver-item8 observations">
            <mat-slide-toggle [(ngModel)]="observation.handoverObservationChecked" (ngModelChange)="buildRejectToolTip()"
            (change)="onChangeValue()" [disabled]="cantEditObservations()">
              <span *ngIf="!observation.handoverObservationChecked">No hay observaciones </span>
              <span *ngIf="observation.handoverObservationChecked">Hay observaciones </span>
              <span>{{ observation.handoverObservationTypeDescription.toLowerCase() }}</span>
            </mat-slide-toggle>
            <mat-form-field *ngIf="observation.handoverObservationChecked">
              <textarea matInput rows="4" maxlength="255" placeholder="Describa observación" [(ngModel)]="observation.handoverObservation" 
                [title]="observation.handoverObservation" (ngModelChange)="buildRejectToolTip()"></textarea>
              <mat-hint class="alert" *ngIf="observation.handoverObservation == ''">
                Este campo es obligatorio.
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="grid-receiver-item-divider"><mat-divider></mat-divider></div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class = "container-columns">
    <!-- File Attachment -->
    <div *ngIf="!operationsVisible && !isHo3">
      <ng-container *ngIf="observationEngineerAttachment?.length < fileLimit">
          <input
            type="file"
            class="file-input"
            accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
            (change)="onFileSelected($event)"
            #fileUpload
            style="display: none"
          />
          <div class="attach" title="Documento">
            <button
              mat-button
              class = "upload-button"
              [disabled]="cantEditObservations()"
              (click)="fileUpload.click()">
              <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
            </button><br/>
            <span>Archivos Excel, PDF e Imágenes</span>
          </div>
      </ng-container>
      <div class = "attachment" *ngFor="let f of observationEngineerAttachment">
        <a
            class="attachment-link"
            href="{{dhoApiUrl}}/{{ f?.filePath }}"
            download="{{ f?.fileOriginalName }}"
            target="_blank"
        >
            {{ f?.fileOriginalName }}
        </a>
        <!-- Boton borrar-->
        <button
            mat-button
            class="delete-button"
            [disabled]="cantEditObservations()"
            (click)="deleteObservationAttachment(f.fileId)"
        >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="operationsVisible && !isHo3">
      <ng-container *ngIf="observationOperationsAttachment?.length < fileLimit">
          <input
            type="file"
            class="file-input"
            accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
            (change)="onFileSelected($event)"
            #fileUpload
            style="display: none"
          />
          <div class="attach" title="Documento">
            <button
              mat-button
              class = "upload-button"
              [disabled]="cantEditObservations()"
              (click)="fileUpload.click()">
              <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
            </button><br/>
            <span>Archivos Excel, PDF e Imágenes</span>
          </div>
      </ng-container>
      <div class = "attachment" *ngFor="let f of observationOperationsAttachment">
        <a
            class="attachment-link"
            href="{{dhoApiUrl}}/{{ f?.filePath }}"
            download="{{ f?.fileOriginalName }}"
            target="_blank"
        >
            {{ f?.fileOriginalName }}
        </a>
        <!-- Boton borrar-->
        <button
            mat-button
            class="delete-button"
            [disabled]="cantEditObservations()"
            (click)="deleteObservationAttachment(f.fileId)"
        >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="isHo3">
      <ng-container *ngIf="observationAttachment?.length < fileLimit">
          <input
            type="file"
            class="file-input"
            accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
            (change)="onFileSelected($event)"
            #fileUpload
            style="display: none"
          />
          <div class="attach" title="Documento">
            <button
              mat-button
              class = "upload-button"
              (click)="fileUpload.click()">
              <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
            </button><br/>
            <span>Archivos Excel, PDF e Imágenes</span>
          </div>
      </ng-container>
      <div class = "attachment" *ngFor="let f of observationAttachment">
        <a
            class="attachment-link"
            href="{{dhoApiUrl}}/{{ f?.filePath }}"
            download="{{ f?.fileOriginalName }}"
            target="_blank"
        >
            {{ f?.fileOriginalName }}
        </a>
        <!-- Boton borrar-->
        <button
            mat-button
            class="delete-button"
            (click)="deleteObservationAttachment(f.fileId)"
        >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
    <div class="acciones" *ngIf="havePermissionAccept && fullscreen">
      <span matTooltip={{rejectButtonToolTip}}>
        <button mat-button class="no-button" (click)="reject();" [disabled]="isDisabledRejectButton()">Rechazar</button>
      </span>
      <button mat-button class="yes-button" (click)="accept();" [disabled]="isDisabledAcceptButton()">Aceptar</button>
    </div>
  </div>
</ng-container>
